import { Autocomplete, Box, Button, Checkbox, Chip, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, MenuItem, Select, TextField, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { getNodesFromPredeceessorValueArray } from "../../helper/helperFunctions";
import "./PredecessorPopupContent.css";
import {checkForCircularDependency } from "../../helper/helpersSubModule";

export default function PredecessorPopup({ open, setOpen,value, params, updateRowDHelper }) {
    const [predecessorList, setPredecessorList] = useState([]);
    const autoCompleteRef = useRef(null);
    const saveButtonRef = useRef(null);
    const cancelButtonRef = useRef(null);

    useEffect(()=>{
        if(value){
            setPredecessorList(getNodesFromPredeceessorValueArray(value,params))
        }
    },[])

    useEffect(() => {
        if (open) {
            setTimeout(() => {
                if (autoCompleteRef.current) {
                    autoCompleteRef.current.focus();
                }
            }, 100);
        }
    }, [open]);

    const handleClose = () => {
        setOpen(false);
    };
    const rows = params.api.getModel().rootNode.allLeafChildren;

    const handleChange = (event,value) => {
        const selectedRow = value;
        setPredecessorList(value || []);
    };

    const handleRemove = (rowIndex) => {
        setPredecessorList((prevList) =>
            prevList.filter((item) => item.rowIndex !== rowIndex)
        );
    };

    const filteredRows = rows.filter(
        (row) => {
            let { predecessorStartDate, predecessorEndDate } = params.colDef.linkedColumns
            return (row.data.id !== params.data.id && !checkForCircularDependency(params.data.id, row.data.id, params.node, params) && !row.data?.checkinagent)
        })
   
    const handleSave = () => {
        //  let siblings = params.node.parent?.childrenAfterAggFilter.filter(item => item.data.id !== params.data.id && item.data?.l_id?.split(".").length === params.data?.l_id?.split(".").length ).map(item => item.data.id);
        let predecessorListofIndexes = predecessorList.map((item) => {
            let isCircularDependency = checkForCircularDependency(params.data.id, item.data.id, params.node, params)
            if (!isCircularDependency) {
                return item.id; // Include the index if it's a sibling
            }
            return null; // Exclude if it's not a sibling
        }).filter(index => index !== null); // Filter out null values

        if (predecessorListofIndexes.length > 0) {
            // Join the indexes into a single string separated by commas
            const joinedIndexes = predecessorListofIndexes.join(",");
            updateRowDHelper(joinedIndexes);
            handleClose();
        }
        else if(value && predecessorList.length==0) {
            updateRowDHelper('');
            handleClose();
        }
            else {
            handleClose();
        }
    };

    const handleTabNavigation = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();     
            
            if (document.activeElement === autoCompleteRef.current) {                
                saveButtonRef.current.focus();
            } else if (document.activeElement === saveButtonRef.current) {                
                cancelButtonRef.current.focus();
            } else if (document.activeElement === cancelButtonRef.current) {
                autoCompleteRef.current.focus();
            }
        }
    };


    const filterOpsFunc = (option, input) => {
        if (input.length > 0) {
            const condition1 = option?.data["primaryCol_es"]?.value?.toLowerCase().includes(input.toLowerCase());
            const inputRowNo = parseInt(input);
            const rowNo = parseInt(option.rowIndex) + 1; 
    
            const condition2 = !isNaN(inputRowNo) && rowNo === inputRowNo;
    
            return condition1 || condition2;

        }

        return true;
    };

    return (
        <Dialog open={open} onClose={handleClose} className="dialogContainer">
            <DialogTitle className="predecessorPopup">
                Edit Predecessors
                <CloseIcon onClick={handleClose} className="CloseButton" />
            </DialogTitle>
            <DialogContent className="dialogContent">
                <Box className="autocompleteContainer">
                    <Typography className="dialogTypography">
                        Select the predecessor:
                    </Typography>
                    <Autocomplete
                        multiple
                        disableCloseOnSelect
                        openOnFocus
                        size="small"
                        renderInput={(params) => (
                            <TextField
                                inputRef={autoCompleteRef}
                                onKeyDown={handleTabNavigation}
                                className="autocompleteInput"
                                {...params}
                                variant="outlined"
                                placeholder={predecessorList.length === 0 ? "Select an option" : null}
                            />
                        )}
                        value={predecessorList}
                        onChange={handleChange}
                        renderTags={(selected, getTagProps) => (
                            <Box className="autocompleteTagsBox">
                                {selected.slice(0, 3).map((item, index) => (
                                    <Box key={index} className="tagBox">
                                        <span>#: {parseInt(item.sourceRowIndex) + 1}</span>
                                        <span> Data: {item.data["primaryCol_es"]?.value}</span>
                                        <IconButton
                                            className="closeIcon"
                                            size="small"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleRemove(item.rowIndex);
                                            }}
                                        >
                                            <CloseIcon fontSize="small" />
                                        </IconButton>
                                    </Box>
                                ))}
                                {selected.length > 3 && (
                                    <Typography className="additionalOptionsText">
                                        +{selected.length - 3} more
                                    </Typography>
                                )}
                            </Box>
                        )}
                        options={filteredRows}
                        getOptionLabel={(option) => `#: ${parseInt(option.sourceRowIndex) + 1} Data: ${option.data["primaryCol_es"]?.value}`}
                        renderOption={(props, option, { selected }) => (
                            <MenuItem {...props} className="menuItemOption">
                                <Checkbox checked={selected} />
                                <Box className="ItemBox">
                                    <Typography>#: {parseInt(option.sourceRowIndex) + 1}</Typography>
                                    <Typography>Data: {option.data["primaryCol_es"]?.value}</Typography>
                                </Box>
                            </MenuItem>
                        )}
                        filterOptions={(options, { inputValue }) => options.filter(option =>
                            {
                            return filterOpsFunc(option, inputValue);
                            }
                        )}
                    />
                </Box>
            </DialogContent>
            <DialogActions className="predecessorPopupActions">
                <Button size="small" ref={saveButtonRef} onKeyDown={handleTabNavigation} onClick={handleSave}>
                    Save
                </Button>
                <Button size="small" ref={cancelButtonRef} onKeyDown={handleTabNavigation} onClick={handleClose}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );

}